import React from "react";
import { Box, Grid } from "@mui/material";
import styles from "./InfoRow.module.scss";

export default function InfoRow({ label, value, sx, sxLabel, invert = false }) {
    return (
        <Grid size={{ xs: 12 }} className={styles.infoRow} sx={{ ...sx }}>
            <Box className={!!invert ? styles.value : styles.label} sx={{ ...sxLabel }}>{label}</Box>
            <Box className={!!invert ? styles.label : styles.value}>{value}</Box>
        </Grid>
    );
}
